import { useEffect } from "react";
import { Link } from "react-router-dom";
import ContactForm from "./components/ContactForm";

const scopeItems = [
  { icon: "ri-movie-2-line", title: "电影资源", desc: "动作、科幻、悬疑、爱情、剧情等类型电影。" },
  { icon: "ri-live-line", title: "电视剧集", desc: "古装、都市、悬疑、医疗等连载剧集资源。" },
  { icon: "ri-bar-chart-box-line", title: "评分与热度", desc: "提供评分、浏览量参考，辅助快速筛选。" },
  { icon: "ri-heart-3-line", title: "个人收藏", desc: "本地收藏喜欢的影片，随时回看。" },
];

const contactItems = [
  { icon: "ri-mail-line", label: "客服邮箱", value: "service@yellowcinema.demo" },
  { icon: "ri-customer-service-2-line", label: "在线客服", value: "每日 09:00 - 22:00" },
  { icon: "ri-global-line", label: "服务方式", value: "线上平台 · 7×24 浏览" },
];

export default function About() {
  useEffect(() => {
    document.title = "关于我们 - 黄色影院";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "了解黄色影院：一个高清电影电视剧资源聚合平台，介绍网站定位、内容范围、联系方式、版权与免责声明。",
      );
    }
  }, []);

  return (
    <div className="w-full">
      <div className="bg-background-100 border-b border-background-300">
        <div className="w-full px-4 md:px-8 py-10 md:py-12">
          <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-4">
            <Link to="/" className="hover:text-primary-400 transition-colors cursor-pointer">
              主页
            </Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-800">关于我们</span>
          </nav>
          <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            关于黄色影院
          </h1>
          <p className="text-sm text-foreground-600 mt-3 max-w-2xl leading-relaxed">
            黄色影院是一个面向影视爱好者的高清电影电视剧资源聚合平台，致力于让浏览、筛选与查询影视内容变得简单高效。
          </p>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 py-10">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_400px] gap-10">
          <div className="space-y-10">
            <section>
              <h2 className="text-xl font-bold text-foreground-950 font-heading mb-4">网站定位</h2>
              <div className="rounded-lg border border-background-300 bg-background-100 p-5 md:p-6 space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                <p>
                  黄色影院专注于电影与电视剧资源的集中展示与整理。我们以清晰的内容分层、灵活的筛选工具和舒适的视觉体验，
                  帮助用户快速定位想看的影片，满足从「随便逛逛」到「精准查找」的多种需求。
                </p>
                <p>
                  平台内容以聚合展示为主，站点结构围绕电影、电视剧两大频道展开，支持按类型、地区、年份、集数等维度筛选，
                  并提供详情页了解影片的完整资料与相关推荐。
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground-950 font-heading mb-4">内容范围</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {scopeItems.map((item) => (
                  <div
                    key={item.title}
                    className="flex items-start gap-3 rounded-lg border border-background-300 bg-background-100 p-4"
                  >
                    <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 border border-secondary-200 shrink-0">
                      <i className={`${item.icon} text-lg text-secondary-900`}></i>
                    </span>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-950 mb-1">{item.title}</h3>
                      <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground-950 font-heading mb-4">版权与免责声明</h2>
              <div className="rounded-lg border border-background-300 bg-background-100 p-5 md:p-6 space-y-3 text-sm text-foreground-600 leading-relaxed">
                <p>
                  <strong className="text-foreground-900">版权声明：</strong>
                  本站所有影视资料、海报及文字介绍均为演示用途的虚构内容，仅用于展示平台功能与页面设计，不涉及任何真实作品的版权。
                </p>
                <p>
                  <strong className="text-foreground-900">免责声明：</strong>
                  本站不提供真实的影视播放、下载或存储服务，页面中的「播放」「下载」等操作均为功能演示，不产生实际内容分发。
                  若本站内容无意间侵犯了您的权益，请通过下方联系方式告知，我们会及时处理。
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground-950 font-heading mb-4">联系方式</h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                {contactItems.map((item) => (
                  <div
                    key={item.label}
                    className="rounded-lg border border-background-300 bg-background-100 p-4"
                  >
                    <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-100 mb-3">
                      <i className={`${item.icon} text-lg text-primary-700`}></i>
                    </span>
                    <p className="text-xs text-foreground-500 mb-1">{item.label}</p>
                    <p className="text-sm text-foreground-900 break-all">{item.value}</p>
                  </div>
                ))}
              </div>
            </section>
          </div>

          <aside>
            <div className="lg:sticky lg:top-24">
              <h2 className="text-xl font-bold text-foreground-950 font-heading mb-2">给我们留言</h2>
              <p className="text-sm text-foreground-600 mb-5">
                有任何建议、资源反馈或合作意向，欢迎填写下面的表单，我们会尽快回复。
              </p>
              <ContactForm />
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
}